var map = {
	"../bundle-group-details/bundle-group-details.module.ngfactory": [
		"Pi6v",
		17
	],
	"../my-suppliers/my-suppliers.module.ngfactory": [
		"p+f8",
		3,
		6,
		21
	],
	"../product-details/product-details.module.ngfactory": [
		"ybgy",
		0,
		13
	],
	"../purchase-orders/purchase-orders.module.ngfactory": [
		"rMQb",
		1,
		3,
		0,
		8
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "crnd";
module.exports = webpackAsyncContext;